import classnames from "classnames";
import { useEffect, useState } from "react";
import Moment from "react-moment";
import { connect } from "react-redux";
import { Button, Input } from "reactstrap";
import {
  addAttrition,
  deleteAttrition,
  editAttrition,
  getAttritions,
} from "../../../actions";
import { formValidation } from "../../../function";
import Datatable from "../../Datatable";
import Paginations from "../../Datatable/Paginations";
import Layouts from "../../Layouts";
import DeleteConfirmation from "../../Modals/DeleteConfirmation.js";
import FormConfirmation from "../../Modals/FormConfirmation";
import SideModal from "../../Modals/SideModal";
import AddAttritionForm from "./AddAttritionForm";
import EditAttritionForm from "./EditAttritionForm";
import { requiredField, validateAttrition } from "./validation";

const Attrition = (props) => {
  const [searchText, setSearchText] = useState(null);
  const [openAddForm, setOpenAddForm] = useState(false);
  const [openEditForm, setOpenEditForm] = useState(false);
  const [attritionList, setAttritionList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [addFormData, setAddFormData] = useState({
    lead_classification: "unknown",
  });
  const [editFormData, setEditFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [, setFormType] = useState(null);
  const [formChanged, setFormChanged] = useState(false);
  const [formConfirm, setFormConfirm] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [deleteAttritionData, setDeleteAttritionData] = useState(null);
  const { user } = props;

  useEffect(() => {
    const getAttritions = async () => {
      const res = await props.getAttritions(props.user.token);
      setAttritionList(res.data);
      setIsLoading(false);
    };
    getAttritions();
  }, [props]);

  const handleChange = (e) => {
    setSearchText(e.target.value);
    setPageActive(1);
  };

  const handlePopup = (e) => {
    if (formChanged) {
      setFormConfirm(true);
      return false;
    }
    setOpenAddForm(e);
    setErrors({});
  };

  const formConfirmPopup = (confirm) => {
    if (confirm) {
      setFormChanged(false);
      setOpenAddForm(false);
      setOpenEditForm(false);
      setErrors({});
    }
    return setFormConfirm(false);
  };

  const handleEditPopup = () => {
    if (formChanged) {
      setFormConfirm(true);
      return false;
    }
    setOpenEditForm(false);
    setErrors({});
  };

  const handleFormChange = (e) => {
    setFormType("add");
    setFormChanged(true);
    setAddFormData({ ...addFormData, [e.target.name]: e.target.value });
  };

  const handleEditFormChange = (e) => {
    setFormType("edit");
    setFormChanged(true);

    return setEditFormData({
      ...editFormData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const postData = {
      ...addFormData,
      is_active: true,
    };

    const validationErrors = validateAttrition(postData, { allowZero: true });

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});

    let validate = formValidation(requiredField, postData);

    if (validate.formIsValid) {
      const res = await props.addAttrition(props.user.token, postData);
      if (res.code >= 200 && res.code < 400) {
        let attritions = attritionList.concat(res.data);
        setAttritionList(attritions);
        setOpenAddForm(false);
        setErrors({});
        setFormChanged(false);
      } else {
        setErrors(res.message);
      }
    } else {
      setErrors(validate.errors);
    }
  };

  const userUpdate = async (e) => {
    if (e) {
      e.preventDefault();
    }

    const postUpdateData = {
      id: editFormData.id,
      package_case: editFormData.package_case,
      percentage: editFormData.percentage,
      count: editFormData.count,
      lead_classification: editFormData.lead_classification,
      is_active: editFormData.is_active,
    };

    let validateField = { ...requiredField };

    const validationErrors = validateAttrition(postUpdateData, {
      allowZero: true,
    });

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});

    let validate = formValidation(validateField, postUpdateData);
    if (validate.formIsValid) {
      apiCall(postUpdateData);
    } else {
      setErrors(validate.errors);
    }
  };

  const apiCall = async (apiData) => {
    const resAttrition = await props.editAttrition(props.user.token, apiData);

    if (resAttrition.code >= 200 && resAttrition.code < 400) {
      let attrition = attritionList.map((item) => {
        if (resAttrition.data.id === item.id) {
          return (item = resAttrition.data);
        }
        return item;
      });
      setAttritionList(attrition);
      setOpenEditForm(false);
      setErrors({});
      setEditFormData({});
      setFormChanged(false);
    } else {
      setErrors(resAttrition.message);
    }
  };

  const deleteConfirmPopup = (confirm) => {
    if (confirm) {
      const deleteAttrition = async () => {
        const res = await props.deleteAttrition(
          props.user.token,
          deleteAttritionData,
        );
        if (res.code >= 200 && res.code < 400) {
          let attritions = attritionList.filter(
            (item) => item.id !== deleteAttritionData.id,
          );
          setAttritionList(attritions);
          setOpenAddForm(false);
          setErrors({});
          setFormChanged(false);
          setDeleteConfirm(false);
          setDeleteAttritionData(null);
        } else {
          setErrors(res.message);
        }
      };
      deleteAttrition();
    } else {
      setDeleteConfirm(false);
      setDeleteAttritionData(null);
    }
  };

  const showAttrition = (attrition) => {
    setOpenEditForm(true);
    setEditFormData(attrition);
  };

  const showDeleteConfirm = (attrition) => {
    setDeleteConfirm(true);
    setDeleteAttritionData(attrition);
  };

  const column = [
    {
      fieldName: "package_case",
      label: "Package Name",
      sort: true,
      customRow: (row) => (
        <div className={classnames({ "opacity-50": !row.is_active })}>
          {/* <img src="./images/user.svg" alt="avtar" /> */}
          <span>{row.package_case}</span>
        </div>
      ),
    },
    {
      fieldName: "percentage",
      label: "Percentage (%)",
      sort: true,
      customRow: (row) => (
        <div className={classnames({ "opacity-50": !row.is_active })}>
          {/* <img src="./images/user.svg" alt="avtar" /> */}
          <span>{row.percentage * 1} %</span>
        </div>
      ),
    },
    {
      fieldName: "count_string",
      label: "Count",
      sort: true,
      customRow: (row) => (
        <span className={classnames({ "opacity-50": !row.is_active })}>
          {row.count}
        </span>
      ),
    },
    {
      fieldName: "lead_classification",
      label: "Lead Classification",
      sort: true,
      customRow: (row) => (
        <span className={classnames({ "opacity-50": !row.is_active })}>
          {row.lead_classification === "lead"
            ? "Lead"
            : row.lead_classification === "leadless"
              ? "Leadless"
              : "Unknown"}
        </span>
      ),
    },
    {
      fieldName: "created_at",
      label: "Added On",
      sort: true,
      customRow: (row) => (
        <span className={classnames({ "opacity-50": !row.is_active })}>
          <Moment format="DD/MM/YYYY">{row.created_at}</Moment>
        </span>
      ),
    },
    {
      fieldName: "",
      label: "Actions",
      width: 80,
      align: "center",
      customRow: (row) => (
        <div className="d-flex justify-content-center">
          {/* Pencil - available to everyone */}
          <Button size="sm" color="default" onClick={() => showAttrition(row)}>
            <span className="fa fa-pencil"></span>
          </Button>

          {/* Delete - only for Super Admin */}
          {user && user.user.role_id === 1 && (
            <Button
              size="sm"
              color="default"
              onClick={() => showDeleteConfirm(row)}
            >
              <span className="fa fa-trash text-danger"></span>
            </Button>
          )}
        </div>
      ),
    },
  ];
  const [showEntry] = useState(10);
  const [pageActive, setPageActive] = useState(1);
  const [totalRecords, setTotalRecords] = useState(attritionList.length);

  const handlePagination = (e) => {
    setPageActive(e);
  };

  const changeTableParams = (total, page) => {
    if (page) setPageActive(page);
    setTotalRecords(total);
  };

  return (
    <Layouts>
      <SideModal show={openAddForm} close={handlePopup}>
        <AddAttritionForm
          errors={errors}
          change={handleFormChange}
          fillData={addFormData}
          submit={onSubmit}
          close={handlePopup}
          requiredField={requiredField}
        />
      </SideModal>

      <SideModal show={openEditForm} close={handleEditPopup}>
        <EditAttritionForm
          errors={errors}
          change={handleEditFormChange}
          fillData={editFormData}
          submit={userUpdate}
          close={handleEditPopup}
          requiredField={requiredField}
          user={user}
        />
      </SideModal>

      <FormConfirmation
        show={formConfirm}
        toggle={handlePopup}
        confirm={formConfirmPopup}
      />

      <DeleteConfirmation
        show={deleteConfirm}
        toggle={handlePopup}
        confirm={deleteConfirmPopup}
      />

      <div className="p-20">
        <div className="card">
          <div className="cardHeader">
            <h3>
              Attritions
              <small className="d-block">
                Total - {attritionList.length}.
              </small>
            </h3>
            <div className="searchBox">
              <Input
                type="text"
                placeholder="Search..."
                name="searchText"
                onChange={(e) => handleChange(e)}
              />
            </div>
            {user && user.user.role_id === 1 && (
              <Button className="linkBtn" onClick={() => handlePopup(true)}>
                <i className="fa fa-plus mr-2"></i>
                Add New Attrition
              </Button>
            )}
          </div>
          <Datatable
            data={attritionList}
            columns={column}
            pageActive={pageActive}
            showEntry={showEntry}
            searchText={searchText}
            changeTableParams={changeTableParams}
            loading={isLoading}
          />
        </div>
        {totalRecords > showEntry && (
          <Paginations
            totalRecords={totalRecords}
            showEntry={showEntry}
            pageActive={pageActive}
            click={handlePagination}
            prevClick={() => setPageActive(parseInt(pageActive) - 1)}
            nextClick={() => setPageActive(parseInt(pageActive) + 1)}
          />
        )}
      </div>
    </Layouts>
  );
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps, {
  getAttritions,
  addAttrition,
  editAttrition,
  deleteAttrition,
})(Attrition);
